module.exports = __webpack_public_path__ + "img/stjy.a7999d32.svg";